module.exports = __webpack_public_path__ + "img/240px-Earth_icon_2.91012f14.png";